<template>
	<div class="card">
		<div class="header">
			<h3>Courtesy Re-pull Dates</h3>
		</div>
		<div class="item">
			<span class="label">Borrower Pull Date</span>
			<span class="value"> {{ borrowerPullDate }} </span>
		</div>
		<div class="item">
			<span class="label">Co-borrower Pull Date</span>
			<span class="value"> {{ coBorrowerPullDate }} </span>
		</div>
		<div class="item">
			<span class="label">CR Final Status</span>
			<span class="value"> {{ finalStatusDate }} </span>
		</div>
	</div>
</template>

<script setup lang="ts">
	withDefaults(defineProps<{
		borrowerPullDate?: string;
		coBorrowerPullDate?: string;
		finalStatusDate?: string;
	}>(), {
		borrowerPullDate: 'N/A',
		coBorrowerPullDate: 'N/A',
		finalStatusDate: 'N/A'
	});
</script>

<style scoped src="@/assets/css/card-rizz.css" />
